import { on } from "svelte/events";

// Single source of truth for Aurora's desktop breakpoint, matching ua_header.liquid's
// own `@media (min-width: 990px)`. The search island picks its shell from this rather
// than mounting both and hiding one with CSS: only one shell may own the combobox, and
// only the mounted one should be measuring itself to fit product cards.
const DESKTOP_QUERY = "(min-width: 990px)";

/** Reactive desktop/mobile breakpoint, backed by matchMedia. */
export function createIsDesktop(): { readonly current: boolean } {
  const mq = typeof window === "undefined" ? undefined : window.matchMedia(DESKTOP_QUERY);
  let isDesktop = $state(mq?.matches ?? false);

  $effect(() => {
    if (!mq) return;
    // Re-read on subscribe: a crossing between init and this first flush would
    // otherwise leave the wrong shell mounted until the next one.
    isDesktop = mq.matches;
    return on(mq, "change", (e) => {
      isDesktop = e.matches;
    });
  });

  return {
    get current() {
      return isDesktop;
    },
  };
}
